<div class="game-timeline-filters" *ngIf="game.status === gameStatuses.closed">
  <a
    [ngClass]="{active: !selectedPeriod}"
    (click)="selectedPeriod = null"
  >Все</a>
  <a
    *ngFor="let period of periods"
    [ngClass]="{active: selectedPeriod === period}"
    (click)="selectedPeriod = period"
  >{{ period }} тайм</a>
  <a
    [ngClass]="{active: selectedPeriod === period}"
    (click)="selectedPeriod = period"
    *ngFor="let period of overtimePeriods"
  >
    <ng-container *ngIf="period !== game.footballGameConfig.penaltyPeriod">{{ period - game.footballGameConfig.periodsCount }} доп. тайм</ng-container>
    <ng-container *ngIf="period === game.footballGameConfig.penaltyPeriod">Серия пенальти</ng-container>
  </a>
  <div class="right-filters">
    <a
      [ngClass]="{active: onlyHighlights}"
      class="fiba-btn"
      (click)="toggleOnlyHighlights()"
    >Highlights</a>
    <a
      [ngClass]="{active: onlyScoreLogs}"
      class="fiba-btn"
      (click)="toggleOnlyScoreLogs()"
    >Только голы</a>
  </div>
</div>
<div class="game-timeline">
  <div class="heading"
    *ngIf="game.status === gameStatuses.closed && !selectedPeriod && sort === 'desc'"
  >
    Игра завершена
  </div>
  <ng-container
    *ngFor="let item of gameLogs; trackBy: identify; let i=index"
  >
    <ng-container
      *ngIf="!selectedPeriod || selectedPeriod === item.period"
    >
      <div class="heading" *ngIf="(i === 0 || gameLogs[i - 1].period != item.period) && sort === 'asc'">
        <ng-container *ngIf="item.period <= game.footballGameConfig.periodsCount">{{ item.period }} тайм</ng-container>
        <ng-container *ngIf="item.period > game.footballGameConfig.periodsCount">
          <ng-container *ngIf="item.period === game.footballGameConfig.penaltyPeriod">Серия пенальти</ng-container>
          <ng-container *ngIf="item.period !== game.footballGameConfig.penaltyPeriod"> {{ item.period - game.footballGameConfig.periodsCount }} доп. тайм</ng-container>
        </ng-container>
      </div>
      <mtg-football-game-timeline-item
        *ngIf="(!onlyScoreLogs || item.isScoreType()) && (!onlyHighlights || item.isHighlight)"
        [game]="game"
        [gameLog]="item"
        [gameUsers]="gameUsers"
        class="timeline-item"
      ></mtg-football-game-timeline-item>
      <div class="heading" *ngIf="(!gameLogs[i + 1] || gameLogs[i + 1].period != item.period) && sort === 'desc'">
        <ng-container *ngIf="item.period <= game.footballGameConfig.periodsCount">{{ item.period }} тайм</ng-container>
        <ng-container *ngIf="item.period > game.footballGameConfig.periodsCount">
          <ng-container *ngIf="item.period === game.footballGameConfig.penaltyPeriod">Серия пенальти</ng-container>
          <ng-container *ngIf="item.period !== game.footballGameConfig.penaltyPeriod"> {{ item.period - game.footballGameConfig.periodsCount }} доп. тайм</ng-container>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
  <div class="heading"
       *ngIf="game.status === gameStatuses.closed && !selectedPeriod && sort === 'asc'"
  >
    Игра завершена
  </div>
</div>
